// TODO: this file will set up code splitting and lazy loading
//  each game will be split off
import DDDNaughtsAndCrosses_CP from '../components/game/gameViews/DDDNaughtsAndCrosses/DDDNaughtsAndCrosses_CP.jsx'
import {DDDNaughtsAndCrosses_Hist_CP} from '../components/game/gameViews/DDDNaughtsAndCrosses/DDDNaughtsAndCrosses_CP.jsx'
import {DDDNaughtsAndCrosses_Rules_CP} from '../components/game/gameViews/DDDNaughtsAndCrosses/DDDNaughtsAndCrosses_CP.jsx'
import {DDDNaughtsAndCrosses_NewForm_CP} from '../components/game/gameViews/DDDNaughtsAndCrosses/DDDNaughtsAndCrosses_CP.jsx'

import TragedyOfTheCommons_CP from '../components/game/gameViews/TragedyOfTheCommons/TragedyOfTheCommons_CP.jsx'
import {TragedyOfTheCommons_Hist_CP} from '../components/game/gameViews/TragedyOfTheCommons/TragedyOfTheCommons_CP.jsx'
import {TragedyOfTheCommons_Rules_CP} from '../components/game/gameViews/TragedyOfTheCommons/TragedyOfTheCommons_CP.jsx'
import {TragedyOfTheCommons_NewForm_CP} from '../components/game/gameViews/TragedyOfTheCommons/TragedyOfTheCommons_CP.jsx'


let GameRegister = {}

GameRegister.GameTypes = {
  'DDDNaughtsAndCrosses': 'DDDNaughtsAndCrosses',
  'TragedyOfTheCommons': 'TragedyOfTheCommons',
}

GameRegister.getGameElements = (gameType) => {
  let gameEles = {
    gameEle: null,
    historyEle: null,
    getPlayerColors: null, // TODO: implement this instead of the getGamePlayerList selector
  }

  // only import the game files we need
  switch (gameType) {
    case GameRegister.GameTypes.DDDNaughtsAndCrosses:
      //import DDDNaughtsAndCrosses_CP from '../components/game/gameViews/DDDNaughtsAndCrosses/DDDNaughtsAndCrosses_CP.jsx'
      gameEles.gameEle = DDDNaughtsAndCrosses_CP
      gameEles.historyEle = DDDNaughtsAndCrosses_Hist_CP
      gameEles.rulesEle = DDDNaughtsAndCrosses_Rules_CP
      gameEles.newForm = DDDNaughtsAndCrosses_NewForm_CP
      break
    case GameRegister.GameTypes.TragedyOfTheCommons:
      gameEles.gameEle = TragedyOfTheCommons_CP
      gameEles.historyEle = TragedyOfTheCommons_Hist_CP
      gameEles.rulesEle = TragedyOfTheCommons_Rules_CP
      gameEles.newForm = TragedyOfTheCommons_NewForm_CP
      break
    
  }
  return gameEles
}

export default GameRegister
